import { useState, useEffect } from 'react';
import { IUserModel, ModelType, IEpisode, Resolution } from '@packages/global';
import { modelApi } from '../../services/user/model.api';

export function useModelConfig(episode: IEpisode | null) {
  const [aspectRatio, setAspectRatio] = useState<string>('16:9');
  const [resolution, setResolution] = useState<Resolution>(Resolution.HD_720P);
  const [generateEndFrame, setGenerateEndFrame] = useState<boolean>(true);
  const [text2imageModelId, setText2imageModelId] = useState<string>('');
  const [imageEditModelId, setImageEditModelId] = useState<string>('');
  const [text2speechModelId, setText2speechModelId] = useState<string>('');
  const [text2imageModels, setText2imageModels] = useState<IUserModel[]>([]);
  const [imageEditModels, setImageEditModels] = useState<IUserModel[]>([]);
  const [text2speechModels, setText2speechModels] = useState<IUserModel[]>([]);

  const [initializedEpisodeId, setInitializedEpisodeId] = useState<string | null>(null);

  useEffect(() => {
    if (episode && episode.id !== initializedEpisodeId) {
      if (episode.videoAspectRatio) setAspectRatio(episode.videoAspectRatio);
      if (episode.resolution) setResolution(episode.resolution);
      if (episode.text2imageModelId) setText2imageModelId(episode.text2imageModelId);
      if (episode.imageEditModelId) setImageEditModelId(episode.imageEditModelId);
      if (episode.text2speechModelId) setText2speechModelId(episode.text2speechModelId);
      setInitializedEpisodeId(episode.id);
    }
  }, [episode, initializedEpisodeId]);

  useEffect(() => {
    const loadModels = async () => {
      try {
        const allModels = await modelApi.getAllModels();
        const t2i = allModels.filter(m => m.modelType === ModelType.TEXT_TO_IMAGE);
        const imgEdit = allModels.filter(m => m.modelType === ModelType.IMAGE_EDIT);
        const t2s = allModels.filter(m => m.modelType === ModelType.TEXT_TO_SPEECH);

        setText2imageModels(t2i);
        setImageEditModels(imgEdit);
        setText2speechModels(t2s);

        // 只在没有值时设置默认值，使用函数式更新避免依赖 state
        setText2imageModelId(prev => (!prev && t2i.length > 0) ? t2i[0].id : prev);
        setImageEditModelId(prev => (!prev && imgEdit.length > 0) ? imgEdit[0].id : prev);
        setText2speechModelId(prev => (!prev && t2s.length > 0) ? t2s[0].id : prev);
      } catch (error) {
        console.error('Failed to load models:', error);
      }
    };
    loadModels();
  }, []); // 只在挂载时加载一次

  return {
    aspectRatio,
    setAspectRatio,
    generateEndFrame,
    setGenerateEndFrame,
    text2imageModelId,
    setText2imageModelId,
    imageEditModelId,
    setImageEditModelId,
    text2speechModelId,
    setText2speechModelId,
    text2imageModels,
    imageEditModels,
    text2speechModels,
  };
}
